import React from 'react';
import cx from 'classnames';

import style from './style.module.scss';

interface Props {
  children: any;
  scoreInfluence: 'detractor' | 'promoter';
}

export default (props: Props) => {
  return (
    <div
      className={cx(
        'u-padding-A-s',
        style.scoreInfluenceAwareContent,
        {
          [style.detractor]: props.scoreInfluence === 'detractor',
          [style.promoter]: props.scoreInfluence === 'promoter'
        }
      )}
    >
      {props.children}
    </div>
  );
};
